export default class fryingpanKv {
  constructor(param) {
    this.param = param;

    this.kv_title_is_show = false;
    this.kv_bg_video = document.getElementById("p-kv__bg-content-video");

    this.is_video_slide = param.displayType === "pc";

    // spのときは高さ設定
    if(!this.is_video_slide) {
      const p_kv = document.getElementById('p-kv')
      p_kv.style.height = window.innerHeight + 'px'
    }
  }

  init() {
    // slider setting
    TweenMax.set("#p-kv__text-title", { opacity: 0 });

    this.playSlider = this.playSlider.bind(this);

    if (this.is_video_slide) {
      // play
      this.kv_bg_video.play();

      this.playTextAppear = this.playTextAppear.bind(this)
      this.kv_bg_video.addEventListener("timeupdate", this.playTextAppear);
    } else {
      TweenMax.to("#p-kv__bg-content-image", 2.0, {
        opacity: 1,
        onComplete: () => {
          this.playTextAppear();
        }
      });
    }
  }

  playTextAppear() {
    if (this.is_video_slide) {
      if (this.kv_bg_video.currentTime <= 3) return;

      // remove event
      this.kv_bg_video.removeEventListener("timeupdate", this.playTextAppear);
    }

    TweenMax.to("#p-kv__text-title", 3.0, { opacity: 1, ease: "power2.out" });
    TweenMax.to("#p-kv__toscroll", 1.2, {
      opacity: 1,
      ease: "power2.out",
      onComplete: () => {
        this.playSlider();
        this.playScrollArrow()
      },
      delay: 1.2
    });
  }

  playSlider() {
    const slideTl = new TimelineMax();

    slideTl.repeat(-1);
    slideTl.repeatDelay(3.0);
    slideTl
      .to("#p-kv__bg-content-2", 1.5, { opacity: 1, ease: " sine.in" }, 0)
      .to("#p-kv__bg-content-3", 1.5, { opacity: 1, ease: " sine.in" }, 4.5)
      .to("#p-kv__bg-content-2", 0.1, { opacity: 0, ease: " sine.in" }, 6.1)
      .to("#p-kv__bg-content-3", 1.5, { opacity: 0, ease: " sine.in" }, 9.0);
  }

  playScrollArrow() {
    const saTl = new TimelineMax({ repeat: -1, repeatDelay: 0.3 })
    saTl
      .fromTo('.js-arrow', 1.2, { y: -8 }, { y: 8, ease: Sine.easeOut }, 0)
      .fromTo('.js-arrow', 0.6, { opacity: 0 },  { opacity: 1, ease: Sine.easeOut }, 0)
      .to('.js-arrow', 0.6, { opacity: 0, ease: Sine.easeOut }, "-=0.6")
  }

  render(_y, _h) {}
  resize(_w, _h, _display) {}
}
